import {useRouteMatch} from "react-router-dom";

import {mapParamSlugToCitySlug} from "../../../../../config/cities";
import {ICityParams} from "../../../common/app/routing/charts_routes";
import {LeafletMap} from "../../map/LeafletMap";

export const LeafletMapPlaceholder = () => {
    const {
        params: {city}
    } = useRouteMatch<ICityParams>();

    const citySlug = mapParamSlugToCitySlug(city ?? "");

    return <LeafletMap city={citySlug} onMarkerClick={() => null} withoutOffers />;
};
